export default Object.freeze({

    ENDPOINT: "https://rockliffehall-api-staging.azurewebsites.net/",


    AUTHORIZATIONURL: "https://identity.rockliffehall.com/connect/authorize"  //https://localhost:5001/connect/authorize
});